import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnDrag extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i className="fa fa-grip-vertical mt-drag-enable"></i>;
    }

    getCellClass(): string {
        let result = super.getCellClass();
        result += " mt-drag-enable";
        return result;
    }
}